<!-- <pre>
  {{facets}} ({{panels.get(0)?.facets}})
</pre> -->
<!-- <pre>
  folded: {{folded}}, show tops: [{{showTops.slice(0,5).join(',')}}]
  hinge: [folded: {{hasFoldedHinge(true, 0)}}, unfolded: {{hasFoldedHinge(false, 0)}}]
  folded: {{hasFoldedOf(0)}}  [{{foldedFacetSetStates[0]?.sectionContent}}, {{foldedFacetSetStates[0]?.section}}, {{foldedFacetSetStates[0]?.footer}}]
  unfolded: {{hasUnfoldedOf(0)}}  [{{unfoldedFacetSetStates[0]?.sectionContent}}, {{unfoldedFacetSetStates[0]?.section}}, {{unfoldedFacetSetStates[0]?.footer}}]
</pre>
 -->
<ng-template #templateTitle>
  <ng-content select="f-facet[name=title],[facet-title]"
    description="View panel Title, alternative to property 'title'"></ng-content>
</ng-template>
<!-- section content -->
<ng-template #templateFolded><ng-content select="f-facet[name=section-folded],[facet-section-folded]"
    description="Provide folded section content, use w-slot components to create columns"></ng-content></ng-template>
<ng-template #templateUnfolded><ng-content select="f-facet[name=section-unfolded],[facet-section-unfolded]"
    description="Provide unfolded section content, use w-slot components to create columns"></ng-content></ng-template>
<ng-template #templatePlaceholder><ng-content select="f-facet[name=placeholder],[facet-placeholder]"
    description="panel content used initially while the component is outside viewport"></ng-content></ng-template>
<!-- w-section -->
<ng-template #templateFoldedSection><ng-content select="w-section[facet-folded]"
    description="Provide folded w-section component"></ng-content></ng-template>
<ng-template #templateUnfoldedSection><ng-content select="w-section[facet-unfolded]"
    description="Provide unfolded w-section component"></ng-content></ng-template>
<!-- footer -->
<ng-template #footerFolded><ng-content select="f-facet[name=footer-folded],[facet-footer-folded]"
    description="Folded footer content"></ng-content></ng-template>
<ng-template #footerUnfolded><ng-content select="f-facet[name=footer-unfolded],[facet-footer-unfolded]"
    description="Unfolded footer content"></ng-content></ng-template>
<!-- actions -->
<ng-template #templateSecondaryActions><ng-content select="[facet-secondary-actions],f-facet[name=secondary-actions]"
    description="use text button or size=medium icon buttons"></ng-content></ng-template>
<ng-template #templatePrimaryAction><ng-content select="[facet-primary-action],f-facet[name=primary-action]"
    description="use text button or size=medium icon button"></ng-content></ng-template>
<ng-template #templateFreeAction><ng-content select="[facet-free-action],f-facet[name=free-action]"
    description="use a regular text button"></ng-content></ng-template>
<ng-template #templateInfo><ng-content select="f-facet[name=info],[facet-info]"></ng-content></ng-template>
<!-- main template -->
<ng-template #complexTemplate let-templateTitle="templateTitle" let-templateInfo="templateInfo"
  let-templateFolded="templateFolded" let-folded="folded" let-facets="facets"
  let-templatePlaceholder="templatePlaceholder" let-templateUnfolded="templateUnfolded"
  let-templateFoldedSection="templateFoldedSection" let-templateUnfoldedSection="templateUnfoldedSection"
  let-footerUnfolded="footerUnfolded" let-footerFolded="footerFolded"
  let-templateSecondaryActions="templateSecondaryActions" let-templateFreeAction="templateFreeAction"
  let-templatePrimaryAction="templatePrimaryAction" let-type="type" let-i="i">
  <!-- PANEL -->
  <ng-container *ngIf="!usePlaceholderOf(i)">

    <!-- selectors (hinge and/or select checkbox)  -->
    <ng-template #selectors>
      <div *ngIf="selectable" class="b-view-panel__hinge b-view-panel__selectable"
        [ngClass]="{'b-view-panel__selected': selected}">
        <w-input-checkbox-one compact [ngModel]="selected" (ngModelChange)="toggleSelection(i, $event)"
          (click)="clickSelector($event)"></w-input-checkbox-one>
      </div>

      <!-- Hinge -->
      <div *ngIf="hasHingeOf(i) && !noHinge" class="b-view-panel__hinge"
          [attr.tabindex]="hasFoldedOf(i) && hasUnfoldedOf(i) ? 0 : null" [attr.role]="hasFoldedOf(i) && hasUnfoldedOf(i) ? 'button' : null"
          [attr.aria-expanded]="hasFoldedOf(i) && hasUnfoldedOf(i) ? !hasFoldedHinge(true, i) : null" (keydown.enter)="toggle(i)"
          (keydown.space)="toggle(i, undefined, $event)" (click)="toggle(i)"
          >
        <div *ngIf="hasFoldedOf(i) && hasUnfoldedOf(i)" class="b-icon b-icon--hinge" >{{hingeIcon(i)}}</div>
      </div>
    </ng-template>


    <ng-template #actions>
      <!-- Action buttons area -->
      <div class="b-view-panel__actions" #actionsSection
        *ngIf="showFacet([F.ACTION_SECONDA,F.ACTION_PRIMA,F.ACTION_FREE], i)">
        <div *ngIf="showFacet(F.ACTION_SECONDA, i)" class="b-view-panel__action-secondary"
          [hide-empty-if]="[useFixedFacets,1]">
          <ng-container *ngTemplateOutlet="templateSecondaryActions"></ng-container>
        </div>
        <div *ngIf="showFacet(F.ACTION_PRIMA, i)" class="b-view-panel__action-primary"
          [hide-empty-if]="[useFixedFacets,1]" #primaryAction>
          <ng-container *ngTemplateOutlet="templatePrimaryAction"></ng-container>
        </div>
        <div *ngIf="showFacet(F.ACTION_FREE, i)" class="b-view-panel__action-free" #freeAction
          [hide-empty-if]="[useFixedFacets,1]">
          <ng-container *ngTemplateOutlet="templateFreeAction"></ng-container>
        </div>
      </div>
    </ng-template>

    <!-- top section - folded/unfolded -->
    <ng-template #topsection>
      <!-- top section -->
      <!-- folded section content -->
      <div *ngIf="showFacet(F.SECTION_FOLDED, i)" class="b-view-panel__section" [attr.data-index]="i"
        [facet]="F.SECTION_FOLDED"
        [hide-empty-if]="[useFixedFacets , 1, showFoldedOf(i) && foldedFacetSetStates[i]?.sectionContent]"
        [style.min-height]="minHeights[i]" #foldedSectionContent>
        <!-- FOLDED SECTION -->
        <ng-container *ngTemplateOutlet="templateFolded"></ng-container>
      </div>

      <!-- alternatively inject whole folded w-section -->
      <div *ngIf="showFacet(F.FOLDED, i)" [attr.data-index]="i" [facet]="F.FOLDED"
        [hide-empty-if]="[useFixedFacets,   1, showFoldedOf(i) && foldedFacetSetStates[i]?.section ]"
        [style.min-height]="minHeights[i]" #foldedSection>
        <ng-container *ngTemplateOutlet="templateFoldedSection"></ng-container>
      </div>


      <!-- unfolded -->
      <div *ngIf="showFacet(F.SECTION_UNFOLDED, i)" class="b-view-panel__section b-view-panel__section-unfolded"
        [attr.data-index]="i"
        [hide-empty-if]="[useFixedFacets,  1, showUnfoldedOf(i) ?? false && unfoldedFacetSetStates[i]?.sectionContent ?? false]"
        [facet]="F.SECTION_UNFOLDED" [style.min-height]="minHeights[i]" #unfoldedSectionContent>
        <!-- UNFOLDED SECTION -->
        <ng-container *ngTemplateOutlet="templateUnfolded"></ng-container>
      </div>
      <div *ngIf="showFacet(F.UNFOLDED, i)" [attr.data-index]="i"
        [hide-empty-if]="[useFixedFacets, 1, showUnfoldedOf(i) && unfoldedFacetSetStates[i]?.section]"
        [facet]="F.UNFOLDED" [style.min-height]="minHeights[i]" #unfoldedSection>
        <ng-container *ngTemplateOutlet="templateUnfoldedSection"></ng-container>
      </div>
    </ng-template>

    <!-- bottom section-->
    <ng-template #bottomsection>
      <!-- footer folded -->
      <div *ngIf="showFacet(F.FOOTER_FOLDED, i)" [attr.data-index]="i"
        [hide-empty-if]="[useFixedFacets,  1, showFoldedOf(i) && foldedFacetSetStates[i]?.footer]"
        [style.border-top]="hasFoldedOf(i) ? '1px solid var(--w-color-gray-9)' : ''" #foldedFooter>
        <ng-container *ngTemplateOutlet="footerFolded"></ng-container>
      </div>
      <!-- footer unfolded -->
      <div *ngIf="showFacet(F.FOOTER_UNFOLDED, i)" [attr.data-index]="i"
        [hide-empty-if]="[useFixedFacets, 1, showUnfoldedOf(i) && unfoldedFacetSetStates[i]?.footer]"
        [style.border-top]="hasUnfoldedOf(i) ? '1px solid var(--w-color-gray-9)' : ''" #unfoldedFooter>
        <ng-container *ngTemplateOutlet="footerUnfolded"></ng-container>
      </div>
    </ng-template>
    <!-- ULF style aggregate -->
    <ng-template #sectionulf>
      <div class="b-view-panel__content-section-top" [attr.hidden]="!showTops[i] ? true : null">
        <div class="b-flex-grow">
          <ng-container *ngTemplateOutlet="topsection"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="bottomsection"></ng-container>
    </ng-template>
    <!-- always ULF -->
    <ng-template #sections>
      <!-- sections in content or section content and we dynamically create section structure -->
      <ng-container *ngTemplateOutlet="sectionulf"></ng-container>
    </ng-template>

    <ng-template #content>
      <!-- title -->
      <div *ngIf="title" [innerHTML]="title" class="b-view-panel--title" [ngClass]="{'b-view-panel--title-only':!showTops[i],
        'b-uppercase': !disableUppercase}">
      </div>
      <div *ngIf="showFacet(F.TITLE, i)" [hide-empty-if]="[useFixedFacets,1]" class="b-view-panel--title"
        [ngClass]="{'b-view-panel--title-only':!showTops[i]}">
        <ng-container *ngTemplateOutlet="templateTitle"></ng-container>
      </div>
      <!-- <pre>
        State: folded: {{folded}} #[{{i}} {{panels.get(i)?.folded}}] 
        Facets: {{facets}} ;  folded: {{folded}}, show tops: [{{showTops.slice(0,5).join(',')}}]
        Show folded: [{{showFacet(F.FOLDED, i)}}, section content: {{showFacet(F.SECTION_FOLDED, i)}}, footer: {{showFacet(F.FOOTER_FOLDED, i)}}]
        Show unfolded: [{{showFacet(F.UNFOLDED, i)}}, section content: {{showFacet(F.SECTION_UNFOLDED, i)}}, footer: {{showFacet(F.FOOTER_UNFOLDED, i)}}]
        Folded: {{foldedFacetSetStates[i]?.sectionContent}}-{{foldedFacetSetStates[i]?.section}}-{{foldedFacetSetStates[i]?.footer}}
        Unfolded: {{unfoldedFacetSetStates[i]?.sectionContent}}-{{unfoldedFacetSetStates[i]?.section}}-{{unfoldedFacetSetStates[i]?.footer}}
      </pre> -->
      <ng-container *ngTemplateOutlet="sections"></ng-container>

      <f-facet-info *ngIf="showFacet(F.INFO, i)" [hide-empty-if]="[useFixedFacets, 1]"><ng-container *ngTemplateOutlet="templateInfo"></ng-container></f-facet-info>
    </ng-template>

    <!-- final assembly of ULF -->
    <ng-template #ulf>
      <div class="b-view-panel__content {{ 'b-view-panel--selectors-' + selectorCountOf(i) }}" [ngClass]="
      {
        'b-view-panel__highlighted': highlighted
      }" (click)="toggle(i,true)">
        <ng-container *ngTemplateOutlet="selectors"></ng-container>
        <div class="b-view-panel__content-sections">
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </div>
      </div>
    </ng-template>
    <ng-container *ngTemplateOutlet="ulf"></ng-container>
  </ng-container>

  <!-- placeholder for lazy loading -->
  <div *ngIf="usePlaceholderOf(i)" [style.min-height.px]="outOfViewportHeightOf(i)" #place [attr.data-index]="i"
    w-not-empty>
    <ng-container *ngTemplateOutlet="templatePlaceholder"></ng-container>
  </div>
</ng-template>
<!-- multipanel -->
<ng-template #multi let-templateTitle="templateTitle" let-templateInfo="templateInfo"
  let-templateFolded="templateFolded" let-folded="folded" let-facets="facets" let-legacy="legacy" 
  let-templatePlaceholder="templatePlaceholder" let-templateUnfolded="templateUnfolded"
  let-templateFoldedSection="templateFoldedSection" let-templateUnfoldedSection="templateUnfoldedSection"
  let-footerUnfolded="footerUnfolded" let-footerFolded="footerFolded"
  let-templateSecondaryActions="templateSecondaryActions" let-templateFreeAction="templateFreeAction"
  let-templatePrimaryAction="templatePrimaryAction" let-selected="selected" let-type="type" let-i="i">
  <div [ngClass]="{
    mainClass: true, 
    'b-view-panel': true, 
    'b-view-panel--legacy': legacy,
    'b-view-panel--has-warning': type === 'warning',
    'b-view-panel--has-error': type === 'error',
    'b-view-panel--has-highlight': type === 'important',
    'b-view-panel--has-success':type === 'success',
    'b-view-panel--selected': selected,
    'b-view-panel--is-folded-out': hasHingeOf(i) && hasFoldedHinge(false,i),
    'b-view-panel__with-hinge': hasHingeOf(i) && !noHinge
    }">
    <ng-container *ngTemplateOutlet="complexTemplate; context: {
      templateTitle, 
      templateInfo,
      templateFolded, 
      templateUnfolded, 
      templateFoldedSection,
      templateUnfoldedSection,
      footerFolded,
      footerUnfolded,
      templatePrimaryAction,
      templateSecondaryActions,
      templateFreeAction,
      templatePlaceholder, 
      facets,
      type,
      selected,
      highlighted,
      folded, 
      legacy,
      i
       }"></ng-container>
  </div>
</ng-template>

<ng-container *ngIf="panels.length>0">
  <!-- multi-panel layout -->
  <ng-container *ngFor="let p of panels; index as i">
    <ng-container *ngTemplateOutlet="multi; context: {
      templateTitle: p.templateTitle, 
      templateInfo: p.templateInfo,
      templateFolded: p.templateFolded, 
      templateUnfolded: p.templateUnfolded, 
      templateFoldedSection: p.templateFoldedSection, 
      templateUnfoldedSection: p.templateUnfoldedSection,
      footerFolded: p.templateFoldedFooter,
      footerUnfolded: p.templateUnfoldedFooter,
      templatePrimaryAction: p.templatePrimaryAction,
      templateSecondaryActions: p.templateSecondaryActions,
      templateFreeAction: p.templateFreeAction,
      templatePlaceholder: p.templatePlaceholder, 
      facets: p.facets,
      type: p.type,
      folded: p.folded, 
      selected: p.selected,
      highlighted: p.highlighted,
      legacy: p.legacy,
      i
       }"></ng-container>
  </ng-container>
</ng-container>
<!-- default - single panel -->
<ng-container *ngIf="panels.length === 0">
  <ng-container *ngTemplateOutlet="complexTemplate; context: {
      templateTitle, 
      templateInfo,
      templateFolded, 
      templateFoldedSection, 
      templateUnfolded, 
      templateUnfoldedSection,
      footerFolded,
      footerUnfolded,
      templatePrimaryAction,
      templateSecondaryActions,
      templateFreeAction,
      templatePlaceholder, 
      i: 0
       }"></ng-container>
</ng-container>
<!-- 
<pre>
  folded: {{folded}}, show tops: [{{showTops.slice(0,5).join(',')}}]
  hinge: [folded: {{hasFoldedHinge(true, 0)}}, unfolded: {{hasFoldedHinge(false, 0)}}]
  folded: {{hasFoldedOf(0)}}  [{{foldedFacetSetStates[0]?.sectionContent}}, {{foldedFacetSetStates[0]?.section}}, {{foldedFacetSetStates[0]?.footer}}]
  unfolded: {{hasUnfoldedOf(0)}}  [{{unfoldedFacetSetStates[0]?.sectionContent}}, {{unfoldedFacetSetStates[0]?.section}}, {{unfoldedFacetSetStates[0]?.footer}}]
</pre> -->